import { currency } from '@/utils/formatters';
import { PROMO_RIBBON_TYPE, PROMO_RIBBON_VARIANT } from './PromoRibbonConstants';

export { PROMO_RIBBON_TYPE, PROMO_RIBBON_VARIANT };

export const RIBBON_CONFIG_MODERN = {
  [PROMO_RIBBON_TYPE.SALE_AMOUNT_RIBBON]: {
    variant: PROMO_RIBBON_VARIANT.INFO,

    canDisplay(product) {
      if (!product && !product.suggestedPrice && !product.act) {
        return false;
      }
      const { suggestedPrice, actualPrice, actualPriceDivider } = product;
      return actualPrice / actualPriceDivider < suggestedPrice;
    },

    getTextContent(product) {
      const { suggestedPrice, actualPrice, actualPriceDivider } = product;
      const savings = suggestedPrice - actualPrice / actualPriceDivider;
      const unit = product.weightProfile ? product.weightProfile.abbrv : 'each';
      return `Save ${currency(savings)} / ${unit}`;
    },
  },

  [PROMO_RIBBON_TYPE.DISCOUNT_NAME_RIBBON]: {
    variant: PROMO_RIBBON_VARIANT.SECONDARY,

    canDisplay(product) {
      return Boolean(product?.autoDiscount);
    },

    getTextContent(product) {
      return product.autoDiscount;
    },
  },
};
